<template>

  <data-form
    :entity="reader"
    :fields="fields"
    model="readers"
    :cancel="false"
  /> 

</template>

<script>
import findAll from 'service/findAll'

export default {
  name: 'reader-form',
  props: {
    reader: {
      type: Object,
      required: true
    }
  },
  computed: {
    fields () {
      return {
        'name': {
        },
        'type': {
          disabled: true
        },
        'direction': {
          type: 'select',
          options: [
            { value: 'in', label: 'in' },
            { value: 'out', label: 'out' },
            { value: 'inout', label: 'inout' }
          ]
        },
        'switch_id': {
          type: 'select',
          options: this.switchOptions,
          disabled: this.reader.type === 'bt'
        }
      }
    }
  },
  mixins: [
    findAll('switches', 'switchOptions', {
      filter ({ controller_id }) { return controller_id === this.reader.controller_id },
      map ({ id, name }) { return { value: id, label: name } }
    })
  ]
}
</script>


// WEBPACK FOOTER //
// ReaderForm.vue?49739adf